import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';

export const createLaunchDarklyProvider = async (
  clientSideID: string,
): Promise<
  ({ children }: { children: React.ReactNode }) => React.JSX.Element
> => {
  return await asyncWithLDProvider({
    clientSideID,
    options: {
      bootstrap: 'localStorage',
    },
    timeout: 5,
  });
};
